import { pianoParser } from "../../../../../common/parameters";
import { parseDo } from "../../../Score/methods/changeDo";
import getKeyOffset from "./getKeyOffset";
import piano from "../../../../piano";
import getScore from "./getScore";
import { INotationNote, INotationThis } from "./interfaces";
import { IBar, ICurrentNote, IFlowData, IPianoData, IPitch, IScore, ISolfaNameType, TShowPitchesTaskData } from "../../../../../common/types";
import getBarlineScore from "./getBarlineScore";
import { getAccidentals } from "../../../Score/score-display/utils";

const addSolfaName = (solfaNameTypes: ISolfaNameType[], newNote: IPitch) => {
    let i = ((newNote.s * 4 + 3) % 7) + ((newNote.o || 0) + 1) * 7;
    let index = solfaNameTypes.findIndex(type => type.i === i);
    if (index === -1) {
        solfaNameTypes.push({ i, show: true, s: newNote.s, o: newNote.o });
        solfaNameTypes.sort((a, b) => a.i - b.i);
    }
};

export default function (this: INotationThis) {
    const { task, plan } = this.props;
    const { preview } = this.props;
    if ((task?.data as IFlowData)?.scores && this.forScores === undefined) this.forScores = 0;
    const barlineScoreData = task?.type === "barline" ? getBarlineScore(getScore(plan, task)!) : undefined;
    const score: IScore = this.scoreEdit
        ? this.state.score!
        : task.type === "barline"
        ? barlineScoreData!.score
        : !(task?.data as IFlowData).scores
        ? getScore(plan, task)!
        : (task.data as IFlowData).scores[this.forScores!];
    const alternatedPitches: IPitch[] = [];
    if (score && score.bars[1] && score.bars[1].notes && score.bars[1].notes.length > 0) {
        this.setState({ playable: true });
        let currentNote: ICurrentNote = {
            bar: 0,
            note: 0,
        };
        if (score.bars[0] === null) {
            currentNote = {
                bar: 1,
                note: 0,
            };
        }
        const notes: (INotationNote | null)[] = [];
        let firstNote;
        const solfaNameTypes: ISolfaNameType[] = [];
        const maxVoice = [0, 1, 2, 3, 4, 5].filter(v => score["bars" + (v || "")]).pop();
        const notesToLoad = new Set<number>();
        const minPiano: number[] = [];
        const maxPiano: number[] = [];
        const accidentals = getAccidentals(score);
        for (let v = 0; v <= maxVoice!; v++) {
            const notesOfCurrentVoice: Set<number> = new Set();
            const bars = score["bars" + (v || "")] as IBar[];
            for (let b = 0; b < bars.length; b++) {
                const doPos = parseDo(accidentals[b]);
                const bar = bars[b];
                if (bar === null || !bar.notes) continue;
                for (let n = 0; n < bar.notes.length; n++) {
                    const note = bar.notes[n];
                    if (note.r) {
                        notes.push({ rest: true });
                    } else {
                        if (!note.p) {
                            if (task?.type === "rhytNotation" && firstNote === undefined) {
                                this.firstNoteLength = note.l;
                                firstNote = notes.length;
                            }
                            notes.push(null);
                            continue;
                        }
                        if (firstNote === undefined) {
                            this.firstNoteLength = note.l;
                            firstNote = notes.length;
                            this.firstPitch = {
                                bar: b,
                                note: n,
                            };
                        }
                        const pitches = Array.isArray(note.p) ? note.p : [note.p];
                        const pianoNotes = pitches.map(pitch => {
                            if (pitch.a === 1 || pitch.a === -1) {
                                if (
                                    !alternatedPitches.find(
                                        ap => ap.s === pitch.s && ap.a === pitch.a && (ap.o || 0) === (pitch.o || 0)
                                    )
                                ) {
                                    alternatedPitches.push(pitch);
                                }
                            }
                            return (
                                60 +
                                pianoParser[pitch.s] +
                                (pitch.a || 0) +
                                getKeyOffset(doPos.value + 6) +
                                doPos.alt +
                                ((pitch.o || 0) + (score["octave" + v] || 0)) * 12
                            );
                        });
                        pianoNotes.forEach(pianoNote => {
                            notesToLoad.add(pianoNote);
                            notesOfCurrentVoice.add(pianoNote);
                        });
                        const newNote = {
                            l: note.l,
                            d: note.d,
                            t: note.t,
                            piano: pianoNotes.length === 1 ? pianoNotes[0] : pianoNotes,
                        };
                        if (note.d) {
                            newNote.d = 1;
                        }
                        addSolfaName(solfaNameTypes, note.p as IPitch);
                        notes.push(newNote);
                    }
                }
            }
            minPiano.push(Math.min.apply(Math, [...notesOfCurrentVoice]));
            maxPiano.push(Math.max.apply(Math, [...notesOfCurrentVoice]));
        }
        if (!preview) {
            notesToLoad.forEach(note => piano.load(note));
        }
        this.firstNote = firstNote;
        const taskScore: IScore = JSON.parse(JSON.stringify(score));
        if (task && task.type === "piano") {
            if ((task.data as IPianoData).withSolfa) {
                taskScore.settings.upperText = 1;
            } else {
                taskScore.settings.upperText = 3;
            }
            taskScore.settings.lowerText = undefined;
            taskScore.settings.lowerText2 = undefined;
        }
        if (task && task.type === "solfaName") {
            taskScore.settings.upperText = 1;
            taskScore.settings.lowerText = undefined;
            taskScore.settings.lowerText2 = undefined;
            if (taskScore.settings.notehead === "solfa") {
                taskScore.settings.notehead = "normal";
            }
        }
        if (task && task.type === "handSign") {
            taskScore.settings.notehead = "handsign";
            taskScore.settings.stick = false;
            taskScore.settings.staffLines = true;
            taskScore.settings.upperText = 1;
            taskScore.settings.lowerText = undefined;
            taskScore.settings.lowerText2 = undefined;
        }
        if (task && (task.type === "intervals" || task.type === "chords3")) {
            taskScore.settings.upperText = 4;
        }
        if (task && (task.type === "rhytKnock")) {
            taskScore.settings.lowerText = undefined;
            taskScore.settings.lowerText2 = undefined;
        }
        if (task && (task.type === "barline")) {
            for (let a = 0; a < 5; a++) {
                delete taskScore!["bars" + (a + 1)];
            }
        }
        if (!preview && (!task || !(task.data as TShowPitchesTaskData).showPitches) && task?.type !== "intervals" && task?.type !== "chords3" && task?.type !== "barline") {
            for (let v = 0; v < 6; v++) {
                const bars = taskScore["bars" + (v || "")] as IBar[];
                if (!bars) continue;
                bars.forEach(bar => {
                    if (!bar) return;
                    bar.notes.forEach(note => {
                        delete note.p;
                    });
                });
            }
        }
        while (
            taskScore.bars[currentNote.bar] &&
            taskScore.bars[currentNote.bar]!.notes.length &&
            taskScore.bars[currentNote.bar]!.notes[currentNote.note].r
        ) {
            currentNote.note++;
            if (taskScore.bars[currentNote.bar]!.notes.length === currentNote.note) {
                currentNote.bar++;
                currentNote.note = 0;
            }
        }
        if (preview) {
            currentNote.note = -1;
        }
        this.setState(
            {
                notes: (task?.data as IFlowData)?.scores ? [...(this.state.notes || []), notes] : notes,
                currentNote,
                solfaNameTypes,
                taskScore,
                doPos: accidentals[1] || accidentals[0],
                minPiano,
                maxPiano,
                alternatedPitches,
                correctBarlines: barlineScoreData?.correctBarlines,
                upbeatLength: barlineScoreData?.upbeatLength,
            },
            () => {
                if ((task?.data as IFlowData)?.scores && this.forScores! < (task.data as IFlowData)?.scores.length - 1) {
                    this.forScores!++;
                    this.setUp();
                }
            }
        );
        return;
    } else {
        return;
    }
}
